// extracted by mini-css-extract-plugin
module.exports = {"BasePage":"BasePage_BasePage__dMxNQ"};